import { HeaderContainer, FullTitle, TextContainer, Title, Highlighted } from './EuphaWorldHeader.style';

const EuphaWorldHeader = () => {
  return (
    <HeaderContainer>
      <TextContainer>
        <FullTitle>
          <p>EUPHAWORLD</p>
        </FullTitle>
        <Title>
          <Highlighted>EUPHA</Highlighted>WORLD
        </Title>
      </TextContainer>
    </HeaderContainer>
  );
}

export default EuphaWorldHeader